/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Node_TextInputs */

const en_fw_node_text = /** @type {(inputs: Fw_Node_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line`)
};

const zh_fw_node_text = /** @type {(inputs: Fw_Node_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`台词`)
};

/**
* | output |
* | --- |
* | "Line" |
*
* @param {Fw_Node_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_node_text = /** @type {((inputs?: Fw_Node_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Node_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_node_text(inputs)
	return zh_fw_node_text(inputs)
});
export { fw_node_text as "fw.node.text" }